export default function Services() {
  const services = [
    {
      icon: 'ri-target-line',
      title: 'Paid Advertising',
      description: 'We run high-converting Facebook and Google ads targeted specifically to car owners in your area who need detailing services.'
    },
    {
      icon: 'ri-window-line',
      title: 'Landing Pages',
      description: 'Custom-built landing pages designed to convert visitors into booked appointments with proven copywriting and design.'
    },
    {
      icon: 'ri-message-3-line',
      title: 'CRM & Follow-up',
      description: 'Automated follow-up system that nurtures leads and books appointments while you focus on detailing cars.'
    },
    {
      icon: 'ri-star-line',
      title: 'Reputation Management',
      description: 'We help you get more 5-star reviews and manage your online reputation to attract premium clients.'
    }
  ];

  return (
    <section id="services" className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="text-[#0066FF] text-sm font-bold tracking-widest uppercase mb-4">
            WHAT WE DO
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-[#0A1628] mb-6">
            We Handle Everything
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            You focus on detailing. We fill your calendar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-2xl transition-all hover:-translate-y-2"
            >
              <div className="w-20 h-20 bg-[#0066FF]/10 rounded-2xl flex items-center justify-center mb-6">
                <i className={`${service.icon} text-4xl text-[#0066FF]`}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#0A1628] mb-4">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed mb-6">{service.description}</p>
              <a href="#" className="text-[#0066FF] font-semibold hover:text-[#0052cc] transition-colors inline-flex items-center gap-2">
                Learn more
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
